module.exports = __webpack_public_path__ + "front/img/i9.f60f394e.png";